export enum Role {
  PRINCIPAL = 'principal',
  COMERCIAL = 'comercial',
  FINANCEIRO = 'financeiro',
  RESPONSAVEL_TECNICO = 'responsavel_tecnico',
  APROVACAO = 'aprovacao',
  ADMINISTRADOR = 'administrador',
  ROOT = 'root',
}
